export const historyConstant = {
  // Get history by lead
  GET_LEAD_HISTORY_R: "GET_LEAD_HISTORY_R",
  GET_LEAD_HISTORY_S: "GET_LEAD_HISTORY_S",
  GET_LEAD_HISTORY_F: "GET_LEAD_HISTORY_F",

  // Clear history state
  CLEAR_HISTORY_STATE: "CLEAR_HISTORY_STATE",
};
